const MuiSwitch = {
  styleOverrides: {
    root: {
      padding: 8,
      '& .MuiSwitch-track': {
        borderRadius: 22 / 2,
        '&:before, &:after': {
          content: '""',
          position: 'absolute',
          top: '50%',
          transform: 'translateY(-50%)',
          width: 16,
          height: 16,
        },
      },
      '& .MuiSwitch-thumb': {
        boxShadow: 'none',
        width: 16,
        height: 16,
        margin: 2,
        color: '#fff',
      },

      '& .Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#0EAB4E !important',
        opacity: '1 !important',
      },

      '& .Mui-disabled + .MuiSwitch-track': {
        opacity: '0.5 !important',
      },
    },
  },
};

  export default MuiSwitch;
